// src/store/callNotificationSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  notification: false,
  inCallNotification: false,
  callType: null,
  isScreenSharing: false,
};

const callNotificationSlice = createSlice({
  name: 'callNotification',
  initialState,
  reducers: {
    setNotification(state, action) {
      state.notification = action.payload;
    },
    setInCallNotification(state, action) {
      state.inCallNotification = action.payload;
    },
    setCallType(state, action) {
      state.callType = action.payload;
    },
    setScreenSharing(state, action) {
      state.isScreenSharing = action.payload;
    },
  },
});

export const {
  setNotification,
  setInCallNotification,
  setCallType,
  setScreenSharing,
} = callNotificationSlice.actions;

export default callNotificationSlice.reducer;